@if (loading()) {
  <div class="contacts-avatars contacts-avatars-loading">
    @for (i of [1, 2, 3, 4]; track i) {
      <div class="contact-item">
        <div class="skeleton-avatar">
          <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        </div>
      </div>
    }
  </div>
}
@if (!loading() && hasContacts$$()) {
  <div class="contacts-avatars">
    @for (contact of displayedContacts$$(); track contact.id) {
      <lib-contact-profile alias="{{ contact.alias }}" role="{{ contact.role }}"></lib-contact-profile>
    }
    @if (remainingCount$$() > 0) {
      <lib-contact-profile count="+{{ remainingCount$$() }}"></lib-contact-profile>
    }
  </div>
} @else {
  <div class="contacts-avatars contacts-avatars-empty">
    <ion-label class="empty-centered-text">{{ 'cameras.details.permissions.noContactsYet' | transloco }}</ion-label>
  </div>
}
